const {Logger} = require('tslog');

module.exports = new Logger({
    name: 'scratch-vm'
});
